/**
 * azureVmPrice模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const azurePrice = {
  // 查询Azure EC2 价格
  queryAzureVMPrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAzurePrice/queryAzureVMPrice`, params);
  },
  // 查询AzureNetwork价格
  queryAzureNetworkPrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAzurePrice/queryAzureNetworkPrice`, params);
  },
  // 查询AzureObjectStorage价格
  queryAzureObjectStoragePrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAzurePrice/queryAzureObjectStoragePrice`, params);
  },
  // 查询Azure数据库价格
  queryAzureDatabasePrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAzurePrice/queryAzureDatabasePrice`, params);
  },
  // 查询Azure公共IP价格
  queryAzurePublicIpPrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAzurePrice/queryAzurePublicIpPrice`, params);
  }
}

export default azurePrice;



// WEBPACK FOOTER //
// ./src/api/azurePrice.js